module.exports = __webpack_public_path__ + "media/images/application/icons/arrow-select-b7964359a44662bc49fc6fe7cd32af02.svg";